import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, ContainerFormRight, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertBlogData, updateBlogData } from '../../api/blog.api'

export const AddBlog = () => {
  const { config, config2 } = useAuth();
  const { fetchBlogList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ file, setFile ] = useState(null);
  const blog = location?.state?.data;
  const formik = useFormik({
    initialValues: {
    blog_heading: blog?.blog_heading,
    blog_sub_heading: blog?.blog_sub_heading,
    blog_content: blog?.blog_content,
    state_name: blog?.state_name,
    },
    onSubmit: async values => {
      // console.log(values, file);
      setLoading(true);
      if (blog) {
        const submit = await updateBlogData({...values, blog_id: blog?.blog_id, file }, config2);
        setResponse(submit);
        setOpen(true);
        fetchBlogList();
        if(submit.status === "success") {
          navigate("/blog");
        }
      } else {
        const submit = await insertBlogData({...values, file}, config2);
        setResponse(submit);
        fetchBlogList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/blog");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Blog Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="blog_heading">Heading:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="blog_heading"
            placeholder="Enter Blog Heading"
            id="blog_heading"
            type="text"
            multiline
            value={formik.values.blog_heading}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="blog_sub_heading">Sub Heading:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="blog_sub_heading"
            placeholder="Enter Blog Sub Heading"
            id="blog_sub_heading"
            type="text"
            multiline
            value={formik.values.blog_sub_heading}
            onChange={formik.handleChange}
            />
        </FormGroup><br />
        <FormGroup>
          <InputLabel htmlFor="blog_content">Content:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="blog_content"
            placeholder="Enter Blog Content"
            id="blog_content"
            type="text"
            multiline
            value={formik.values.blog_content}
            onChange={formik.handleChange}
            />
        </FormGroup><br />
        <FormGroup>
          <InputLabel htmlFor="file">Blog Image:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="file"
            placeholder="Select Image"
            id="file"
            type="file"
            // value={file}
            onChange={(e) => setFile(e.target.files[0])}
          />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/blog")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={blog?.image_file}
                  alt={blog?.image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={blog?.image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
    </Container>
    </>
  )
};
